import Moment from "react-moment";
import 'moment/locale/it';
import { useTranslation } from "react-i18next";
import { useEffect, useRef } from "react";
import { isGroupLinkActive } from "../../utils/helpers";

const DayTimeslot = (props: any) => {
  const timeslot = props.timeslot || {};
  const active = props.active ?? false;
  const { t } = useTranslation();

  const scrollRef = useRef<null | HTMLDivElement>(null);

  useEffect(() => {
    if (active) {
      scrollRef.current?.scrollIntoView()
    }
  }, [active])

  return (
    <div className={`DayTimeslotBox ${active ? "active" : ''}`}
      ref={active ? scrollRef : null}
    >
      <span onClick={props.handelClick}>

        <h6 onClick={props.handelClick}>
          <Moment locale='it' format="HH:mm">{timeslot.startDate}</Moment>
          &nbsp;-&nbsp;
          <Moment format="HH:mm">{timeslot.endDate}</Moment>
        </h6>

        <p>{t('seats')}: <b>{timeslot.maximumAttendances}</b></p>
        <p>
          {t('reserved-seats')}:
          &nbsp;<b>{timeslot.savedAttendances}</b>
          {isGroupLinkActive(timeslot.categoryObject?.groupLink) &&
            <>
              &nbsp;<span
                className="material-icons"
                title={`${t('timeslot.linked-message')}\n${t('timeslot.linked-seats-message')}`}
              >
                help
              </span>
            </>
          }
        </p>
      </span>
    </div >
  )
}

export default DayTimeslot
